import withListarAreasDictado from "../../hoc/Docentes/withListarAreasDictado"
import AreasDictado from "../../view/components/RegistroUsuarios/Clasificacion/EditarTemasArea/AreasDictado";

export default withListarAreasDictado(AreasDictado);